/* eslint-disable */


/**
 * Create styles for `<OrderDetailVolumeField />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderDetailVolumeField />` styles
 */
const orderDetailsVolumeFieldStyles = ({ theme }) => ({});

export default orderDetailsVolumeFieldStyles;
